import './Footer.css'

export default function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className="footer">
      <div className="container footer__inner">
        <div className="footer__left">
          <div className="footer__logo">
            <LogoMark />
            <span className="footer__wordmark">NorthCortex</span>
          </div>
          <p className="footer__company">
            NorthCortex Ltd &middot; Registered in England and Wales
          </p>
          <p className="footer__copy">&copy; {year} NorthCortex Ltd. All rights reserved.</p>
        </div>

        <div className="footer__right">
          <a href="mailto:hello@northcortex.co.uk" className="footer__link">
            <EmailIcon />
            hello@northcortex.co.uk
          </a>
          <a href="https://www.linkedin.com/company/northcortex" className="footer__link" target="_blank" rel="noopener noreferrer">
            <LinkedInIcon />
            LinkedIn
          </a>
        </div>
      </div>
    </footer>
  )
}

function LogoMark() {
  return (
    <svg width="28" height="28" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect x="14" y="14" width="46" height="172" fill="white"/>
      <rect x="140" y="14" width="46" height="172" fill="white"/>
      <line x1="60" y1="42" x2="140" y2="158" stroke="#2E86C1" strokeWidth="6" strokeLinecap="round"/>
      <circle cx="60" cy="42" r="22" fill="#143d59"/>
      <circle cx="60" cy="42" r="15" fill="#2E86C1"/>
      <circle cx="100" cy="100" r="22" fill="#143d59"/>
      <circle cx="100" cy="100" r="15" fill="#2E86C1"/>
      <circle cx="140" cy="158" r="22" fill="#143d59"/>
      <circle cx="140" cy="158" r="15" fill="#2E86C1"/>
    </svg>
  )
}

function EmailIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
      <polyline points="22,6 12,13 2,6"/>
    </svg>
  )
}

function LinkedInIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
      <rect x="2" y="9" width="4" height="12"/>
      <circle cx="4" cy="4" r="2"/>
    </svg>
  )
}
